import api from './api';
import GetQuoteRequestFactory from '../factories/get-quote-request-factory';

const apiUrl = PROCESSING_API_URL; // eslint-disable-line no-undef

export default {
  getQuote(searchParams) {
    const params = new GetQuoteRequestFactory(searchParams).build();

    return api
      .post(`${apiUrl}/public/processing/v1/quote`, params)
      .then(({ data }) => data);
  },

  createTransactionFromSession() {
    return api
      .post('/api/transaction/create-from-session/')
      .then(({ data }) => data);
  },
};
